import React, { ReactNode, useCallback, useState, useEffect, useRef, forwardRef, useImperativeHandle } from 'react';
import {
  Box,
  Button,
  Icon,
  Icons,
  Modal,
  Overlay,
  OverlayBackdrop,
  OverlayCenter,
  Spinner,
  Text,
  Tooltip,
  TooltipProvider,
  as,
} from 'folds';

export type RepairOrderProps = {
  RepairInfo: object;
  mid: string;
  setMid: React.Dispatch<React.SetStateAction<string>>;
  msgId?: string;
  setDocInfo: React.Dispatch<React.SetStateAction<unknown>>;
  body: string;
  setShowDocArea: React.Dispatch<React.SetStateAction<boolean>>;
};



export function RepairOrder({RepairInfo, mid, setMid, msgId, setDocInfo, body, setShowDocArea}: RepairOrderProps) {

    const [focusUpdate, setFocusUpdate] = useState(true);

    const itemName = {
        "command": "repaire",
        "repaire number": "報修單號",
        "date": "日期",
        "unit": "承辦單位",
        "name": "承辦人姓名",
        "extension": "分機",
        "docnumber": "文號",
        "user problem": "問題"
    };

    useEffect(() => {
        // if(mid === msgId) {
        setDocInfo({
            RepairInfo,
            itemName,
            msgId,
            body,
            // requestClose: () => {setShowDocArea(false);},
            // remoteSwitcher: () => {setShowDocArea(true); setFocusUpdate(!focusUpdate);},
        })
        // }
    },[]);



    // setShowDocArea(true);
    // setMid(`${msgId}`);

    /*
    return (
        <Box grow="Yes" style={{width: '800px'}}>
            <Overlay open className={'RepairOrder'} style={{marginLeft: '850px', zIndex: '10'}} >
            <table>
                <tbody>
                {Object.entries(RepairInfo).map((item)=> (item[0] === 'command' || item[0] === 'agent response') ? null : <tr key={item[0]}><th>{itemName[item[0]]}</th><td>{item[1]}</td></tr>)}
                </tbody>
            </table>
            </Overlay>
        </Box>
    );
    */
}